<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <h1 class="text-title-underline mb-4">{{ t('counselingReports.title') }}</h1>
        <template v-if="counselingReportDetails">
          <div class="mb-2">
            <router-link class="text-xs md:text-sm text-blue-500 hover:text-blue-400 hover:border-b border-blue-400"
              to="/counseling-reports/">
              ＜ カウンセリングレポート一覧へ戻る
            </router-link>
          </div>
          <div class="flex flex-col md:flex-row md:justify-between md:items-center">
            <div class="mb-1 border-b border-gray-500 w-full mr-5 flex items-center">
              <div class="mr-10">
                レポートID：{{ counselingReportDetails.id }}
              </div>
              <div class="text-orange-700">
                カウンセラー：{{ counselingReportDetails.user.name }}
              </div>
            </div>
            <div class="flex justify-end md:w-full md:justify-end mt-2 md:mt-0">
              <template v-if="user.user.id === counselingReportDetails.user_id">
                <button @click="copyReport"
                  class="text-gray-700 flex justify-center items-center w-28 py-1 bg-white border border-gray-700 hover:bg-gray-50 rounded mb-2 mr-2">
                  <base-svg-icon class="min-w-[1.3rem] mr-1" :path="mdiContentCopy" />
                  <div>複製</div>
                </button>
                <button @click="editReport"
                  class="text-mentalncText flex justify-center items-center w-28 py-1 bg-white border border-mentalncText hover:bg-gray-50 rounded mb-2 mr-2">
                  <base-svg-icon class="min-w-[1.3rem] mr-1" :path="mdiFileEdit" />
                  <div>編集</div>
                </button>
                <button @click="viewDeleteCheck"
                  class="text-red-500 flex justify-center items-center w-28 py-1 bg-white border border-red-600 hover:bg-gray-50 rounded mb-2">
                  <base-svg-icon class="min-w-[1.3rem] mr-1" :path="mdiDelete" />
                  <div>削除</div>
                </button>
              </template>
            </div>
          </div>
          <div class="bg-white shadow-md p-4 text-sm md:text-base border-2 border-mentalncText">
            <template v-if="counselingReportDetails.user_id === userId">
              <div class="mb-0.5 flex justify-end">
                <p class="px-3 rounded-full text-white"
                  :class="counselingReportDetails.is_hidden ? 'bg-gray-500' : 'bg-green-500'">{{
                    counselingReportDetails.is_hidden ? 'レポート非公開中' : 'レポート公開中' }}</p>
              </div>
            </template>
            <fieldset class="border border-gray-700 rounded p-1 w-full mb-6">
              <legend class="flex items-center">
                <base-svg-icon class="w-7 md:w-7 mr-1" :path="mdiAccount" />
                <h2 class="text-lg font-bold">クライアント情報</h2>
              </legend>
              <div class="p-2">
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12">
                  <div class="flex col-span-2 justify-between">
                    <p class="font-bold ml-2">ニックネーム</p>
                    <p class="border-r-4 border-gray-200 mr-2"></p>
                  </div>
                  <div class="col-span-2">
                    <p><span class="font-bold mr-1">{{ counselingReportDetails.counseling_client.nick_name }}</span>さん</p>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-2 justify-between">
                    <p class="font-bold ml-2">年齢</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-2">
                    <p>{{ counselingReportDetails.counseling_client.age }}</p>
                  </div>
                  <div class="flex mb-1 col-span-4 md:col-span-8">
                    <div v-if="counselingReportDetails.counseling_client.age_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.counseling_client.age_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12">
                  <div class="flex col-span-2 justify-between">
                    <p class="font-bold ml-2">性別</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-2">
                    <p>{{ counselingReportDetails.counseling_client.gender }}</p>
                  </div>
                  <div class="flex mb-1 col-span-4 md:col-span-8">
                    <div v-if="counselingReportDetails.counseling_client.gender_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.counseling_client.gender_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-2 justify-between">
                    <p class="font-bold ml-2">居住地</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-2">
                    <p>{{ counselingReportDetails.counseling_client.residence }}</p>
                  </div>
                  <div class="flex mb-1 col-span-4 md:col-span-8">
                    <div v-if="counselingReportDetails.counseling_client.residence_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.counseling_client.residence_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12">
                  <div class="flex col-span-2 justify-between">
                    <p class="font-bold ml-2">出身地</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-2">
                    <p>{{ counselingReportDetails.counseling_client.birthplace }}</p>
                  </div>
                  <div class="flex mb-1 col-span-4 md:col-span-8">
                    <div v-if="counselingReportDetails.counseling_client.birthplace_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.counseling_client.birthplace_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-2 justify-between">
                    <p class="font-bold ml-2">兄弟構成</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-2">
                    <p>{{ counselingReportDetails.counseling_client.sibling }}</p>
                  </div>
                  <div class="flex mb-1 col-span-4 md:col-span-8">
                    <div v-if="counselingReportDetails.counseling_client.sibling_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.counseling_client.sibling_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12">
                  <div class="flex col-span-2 justify-between">
                    <p class="font-bold ml-2">生育環境</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-2">
                    <p>{{ counselingReportDetails.counseling_client.circumstance }}</p>
                  </div>
                  <div class="flex mb-1 col-span-4 md:col-span-8">
                    <div v-if="counselingReportDetails.counseling_client.circumstance_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.counseling_client.circumstance_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-4 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">詳細な生育環境</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-4 md:col-span-10">
                    <p>{{ counselingReportDetails.counseling_client.circumstance_others_detail }}</p>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border border-gray-700 rounded p-1 w-full mb-6">
              <legend class="flex items-center">
                <base-svg-icon class="w-7 md:w-7 mr-1" :path="mdiLaptopAccount" />
                <h2 class="text-lg font-bold">セッション詳細</h2>
              </legend>
              <div class="p-2">
                <div class="mb-2 p-2 grid grid-cols-4 md:grid-cols-12">
                  <div class="flex col-span-2 justify-between">
                    <p class="font-bold ml-2">実施日</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-2">
                    <p>{{ dayjs(counselingReportDetails.implementation_date).format('YYYY年MM月DD日') }} </p>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-3 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">形式</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-3 md:col-span-5">
                    <p>{{ counselingReportDetails.session_format }}</p>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.session_format_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.session_format_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12">
                  <div class="flex col-span-6 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">クライアントの主訴</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-6 md:col-span-10">
                    <p>{{ counselingReportDetails.client_concerns }}</p>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-6 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">セッションテーマ</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-6 md:col-span-5">
                    <div class="grid-cols-1 mr-2" v-for="theme in counselingReportDetails.counseling_session_themes"
                      :key="theme.id">
                      <p :style="{ color: theme.theme_color }" class="text-xs md:text-sm"><span
                          class="text-black">・</span>{{ theme.session_theme_name }}</p>
                    </div>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.session_theme_others" class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.session_theme_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12">
                  <div class="flex col-span-6 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">セッションのG</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-6 md:col-span-10">
                    <p>{{ counselingReportDetails.session_g }}</p>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-6 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">セッションのR</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-6 md:col-span-10">
                    <p>{{ counselingReportDetails.session_r }}</p>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12">
                  <div class="flex col-span-3 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">セッションの種別</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-3 md:col-span-5">
                    <p>{{ counselingReportDetails.session_type }}</p>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.session_type_others" class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.session_type_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-6 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">扱ったノイズ</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-6 md:col-span-5">
                    <div class="mr-2" v-for="theme in counselingReportDetails.counseling_mental_noises" :key="theme.id">
                      <p :style="{ color: theme.theme_color }" class="text-xs md:text-sm"><span
                          class="text-black">・</span>{{ theme.mental_noise_name }}</p>
                    </div>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.session_mentalnoise_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.session_mentalnoise_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12">
                  <div class="flex col-span-6 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">セッション後の所見等</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-6 md:col-span-10">
                    <p>{{ counselingReportDetails.session_findings }}</p>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-3 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">時間</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-3 md:col-span-5">
                    <p>{{ counselingReportDetails.session_time }}</p>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.session_time_others" class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.session_time_others }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border border-gray-700 rounded p-1 w-full mb-6">
              <legend class="flex items-center">
                <base-svg-icon class="w-7 md:w-7 mr-1" :path="mdiChartLine" />
                <h2 class="text-lg font-bold">経過</h2>
              </legend>
              <div class="p-2">
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12">
                  <div class="flex col-span-6 md:col-span-2 justify-between">
                    <p class="font-bold ml-2 text-sm">前回からのクライアントの現実変化</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-6 md:col-span-5">
                    <div class="grid-cols-1 mr-2" v-for="changed in counselingReportDetails.counseling_client_changeds"
                      :key="changed.id">
                      ・{{ changed.client_changed_name }}
                    </div>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.session_changed_others"
                      class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.session_changed_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-3 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">継続予定</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-3 md:col-span-5">
                    <p>{{ counselingReportDetails.continue_plan }}</p>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.continue_plan_others" class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.continue_plan_others }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border border-gray-700 rounded p-1 w-full mb-6">
              <legend class="flex items-center">
                <base-svg-icon class="w-7 md:w-7 mr-1" :path="mdiHandshake" />
                <h2 class="text-lg font-bold">ビジネスについて</h2>
              </legend>
              <div class="p-2">
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12">
                  <div class="flex col-span-3 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">経路</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-3 md:col-span-5">
                    <p>{{ counselingReportDetails.client_route }}</p>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.client_route_others" class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.client_route_others }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100">
                  <div class="flex col-span-3 md:col-span-2 justify-between">
                    <p class="font-bold ml-2">価格</p>
                    <p class="border-r-4 border-gray-300 mr-2"></p>
                  </div>
                  <div class="col-span-3 md:col-span-5">
                    <p>{{ counselingReportDetails.session_price }}</p>
                  </div>
                  <div class="flex mb-1 col-span-6 md:col-span-5">
                    <div v-if="counselingReportDetails.session_price_others" class="flex items-center ml-2 text-gray-700">
                      <base-svg-icon class="min-w-[1rem]" :path="mdiCommentTextOutline" />
                      <p class="text-sm ml-1">{{ counselingReportDetails.session_price_others }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </template>
        <template v-else>
          <div class="padding-auth-contents">
            カウンセリングレポートが見つかりませんでした。
          </div>
        </template>
      </div>
      <el-dialog v-model="dialogVisible" title="確認画面" :width="store.state.base.responsive.isMD ? '80%' : '40%'">
        <span>このカウンセリングレポートを削除しますか？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button class=" text-gray-600" @click="dialogVisible = false">キャンセル</el-button>
            <el-button class=" text-gray-600" type="danger" @click="deleteReport">
              削除
            </el-button>
          </div>
        </template>
      </el-dialog>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, ref } from 'vue'
import { useStore } from '@/store/index'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
import { CounselingReportAttributes } from '@/types/models/counseling-report'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

import { dayjs } from '@/plugins/dayjs'

import { mdiCommentTextOutline, mdiAccount, mdiLaptopAccount, mdiChartLine, mdiHandshake, mdiFileEdit, mdiDelete, mdiContentCopy, mdiFileHidden } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { ElMessage } from 'element-plus'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BaseSvgIcon
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const dialogVisible = ref(false)
    const userId = computed(() => store.state.user.user.id)

    const initialize = () => {
      axios.get<ApiResponse<CounselingReportAttributes>>(`/counseling-reports/${route.params.counseling_report_id}`)
        .then(response => {
          store.commit('counselingReport/setCounselingReportDetails', response.data.payload)
        })
        .catch(error => {
          console.error('Error fetching counseling report details:', error)
        })
    }

    const user = computed(() => {
      return store.state.user
    })

    onMounted(() => {
      initialize()
    })

    const counselingReportDetails = computed(() => store.state.counselingReport.counselingReportDetails)

    // counselingReportDetailsの中身をログで確認(awaitが必要)

    const editReport = () => {
      router.push(`/counseling-reports/edit/${route.params.counseling_report_id}`)
    }

    const copyReport = async () => {
      router.push(`/counseling-reports/copy/${route.params.counseling_report_id}`)
    }

    const deleteReport = async () => {
      try {
        await axios.delete(`/counseling-reports/${route.params.counseling_report_id}`);
        dialogVisible.value = false
        await store.dispatch('counselingReport/reloadCounselingReports')
        ElMessage({ message: 'カウンセリングレポートを削除しました。', type: 'success' })
        router.push('/counseling-reports/')
      } catch (error) {
        ElMessage({ message: 'カウンセリングレポートの削除に失敗しました。', type: 'error' })
        dialogVisible.value = false
      }
    }

    const viewDeleteCheck = async () => {
      dialogVisible.value = true
    }



    return {
      store,
      t,
      counselingReportDetails,
      mdiCommentTextOutline,
      mdiAccount,
      mdiLaptopAccount,
      mdiChartLine,
      mdiHandshake,
      mdiContentCopy,
      mdiFileHidden,
      dayjs,
      user,
      mdiFileEdit,
      mdiDelete,
      editReport,
      deleteReport,
      viewDeleteCheck,
      dialogVisible,
      copyReport,
      userId
    }
  }
})
</script>
